import Vue from "vue";
import Vuex from "vuex";
import { admin } from "./store-modules/adminEdit.js";
import user from "./store-modules/user.js";
import article from "./store-modules/article.js";
import { drawers } from "./store-modules/drawers.js";
import calendar from "./store-modules/calendar.js";
import snackbar from "./store-modules/snackbar.js";
import { Rest, Api } from "@/utils";

Vue.use(Vuex);

const colors = ["green", "purple", "indigo", "cyan", "teal", "orange"];
const classNameInUrl =
  location.hostname != "localhost" ? location.hostname.split(".")[0] : "java18";

function checkIfMobile() {
  const os = navigator.userAgent;
  const isMobile =
    os.includes("Android") || os.includes("iPhone") || window.innerWidth < 993;
  const f = isMobile ? "add" : "remove";
  document.body.classList[f]("mobile");
  return isMobile;
}

// Try to separate globals as much as possible with modules.
export default new Vuex.Store({
  modules: {
    admin,
    user,
    article,
    drawers,
    calendar,
    snackbar,
  },
  state: {
    courses: [],
    cover: "",
    currentSchoolName: "",
    currentKlassName: "Laddar",
    currentKlass: classNameInUrl,
    klasses: {},
    klassesArr: [],
    langEng: false,
    search: "",
    isMobile: false,
    windowWidth: window.innerWidth,
    schools: [],
    users: [],
    personnel: [],
  },
  mutations: {
    setCurrentKlass(state, value) {
      state.currentKlass = value;
    },
    resetCurrentKlass(state) {
      state.currentKlass = classNameInUrl;
    },
    setCourses(state, value) {
      state.courses = value;
    },
    setSchools(state, value) {
      state.schools = value;
      const klassOwningSchool = value
        .filter((school) =>
          school.klasses.find((k) => k.slug == classNameInUrl)
        )
        .map((school) => school.name)[0];
      state.currentSchoolName = klassOwningSchool ? klassOwningSchool : "";
    },
    setKlasses(state, value) {
      let classNameUsingSlug = value.filter((klass) => klass.slug == classNameInUrl)

      if(classNameUsingSlug[0].cover.trim()) {
        state.cover = classNameUsingSlug[0].cover
      } else {
        state.cover = "/uploads/images/default-cover.jpg"
        localStorage['background-image'] = "/uploads/images/default-cover.jpg"
      }

      classNameUsingSlug = classNameUsingSlug.map((klass) => klass.name)[0];

      state.currentKlassName = classNameUsingSlug
        ? classNameUsingSlug
        : state.user.langEng
          ? "Unknown domain"
          : "Okänd domän";

      let colorID = 0;
      for (let k of value) {
        state.klassesArr.push(k);
        k.color = colors[colorID];
        Vue.set(state.klasses, k.slug, k);
        colorID++;
        if (colorID > 5) colorID = 0;
      }
    },
    initResizeListener(state) {
      state.isMobile = checkIfMobile();
      window.addEventListener("resize", () => {
        state.isMobile = checkIfMobile();
      });
    },
    setUsers(state, val) {
      state.users = val.map((m) => {
        if (m.id == this.state.user.loggedInUser.id) {
          m = this.state.user.loggedInUser;
        }
        m.name = m.firstname
          ? m.firstname + ' ' + m.lastname
          : m.email || (state.user.langEng ? "Unknown name" : "Okänt namn");
        m.disabled = !this.getters.isAdmin && m.id === state.user.loggedInUser.id;
        return m
      });
    },
    setPersonnel(state, val) {
      state.personnel = val.map((m) => {
        if (m.id == this.state.user.loggedInUser.id) {
          m = this.state.user.loggedInUser;
        }
        m.name = m.firstname
          ? m.firstname + ' ' + m.lastname
          : m.email || (state.user.langEng ? "Unknown name" : "Okänt namn");
        return m
      });
    },
  },
  actions: {
    async loadInitialEntities(context) {
      if (this.state.user.loggedInUser) {
        if (this.getters.isAdmin) {
          const schools = await Rest.get("School", {
            sort: { name: "ASC" },
            eager: { klasses: true },
          });
          context.commit("setSchools", schools);
        }

        const courses = await Rest.get("Course", { sort: { name: "ASC" } });
        context.commit("setCourses", courses);
      }

      const klasses = await Rest.get("Klass", {
        sort: { name: "ASC" },
        eager: { courses: true, school: true },
      });
      
      context.commit("setKlasses", klasses);

      if (this.state.user.loggedInUser) {
        let users = await Api.get("getKlassStudents");
        if (this.getters.isAdmin) {
          let personnel = await Api.get("getSchoolPersonnel");
          context.commit("setPersonnel", personnel);
          users = personnel.concat(users);
        } else {
          context.commit("setPersonnel", [this.state.user.loggedInUser]);
        }
        context.commit("setUsers", users);
      }
    },
    resetKlassToInitial(context) {
      context.commit("setCurrentKlass", classNameInUrl);
    },
  },
  getters: {
    classNameInUrl: () => classNameInUrl,
  },
});
